import { Box, Typography, styled } from '@mui/material';

// Both lines wrap rather than ellipsize, so wider text spacing never hides the value (WCAG 1.4.12).
const wrap = {
  whiteSpace: 'normal' as const,
  overflowWrap: 'anywhere' as const,
};

export const Content = styled(Box)(({ theme }) => ({
  ...theme.typography.h5,
  color: theme.palette.text.primary,
  ...wrap,
}));

export const Label = styled(Typography)(({ theme }) => ({
  ...theme.typography.overline,
  color: theme.palette.text.secondary,
  fontSize: '0.7rem',
  marginBottom: theme.spacing(1),
  ...wrap,
}));
